module.exports = __webpack_public_path__ + "img/891-625f56.png";